import { Box, BoxProps, Spacer } from '@alto-avios/alto-ui'

type DividerProps = {
  paddingTop?:
    | 'none'
    | 'lg'
    | 'sm'
    | 'xs'
    | '2xs'
    | 'xl'
    | '2xl'
    | 'md'
    | '3xs'
    | '4xs'
    | '5xs'
    | '3xl'
    | '4xl'
    | '5xl'
  paddingBottom?:
    | 'none'
    | 'lg'
    | 'sm'
    | 'xs'
    | '2xs'
    | 'xl'
    | '2xl'
    | 'md'
    | '3xs'
    | '4xs'
    | '5xs'
    | '3xl'
    | '4xl'
    | '5xl'
  width?: BoxProps['width']
  height?: BoxProps['height']
  thickness?: string
  vertical?: boolean
}

export const Divider = ({
  paddingBottom = '4xs',
  paddingTop = '4xs',
  width = '100%',
  height = '100%',
  thickness = '1px',
  vertical = false,
}: DividerProps) => {
  return (
    <Box flexDirection={vertical ? 'row' : 'column'} alignItems="center">
      <Spacer h={paddingTop} />
      <Box
        backgroundColor="layer3"
        height={vertical ? height : thickness}
        width={vertical ? thickness : width}
        aria-hidden
      />
      <Spacer h={paddingBottom} />
    </Box>
  )
}
